import dayjs from "dayjs";

export const dateOfBirthFormatter = (dob) => {
    return dayjs.utc(dob).format("MM/DD/YYYY");
}

export const dateFormatter = dateOfBirthFormatter;

export function parseDate(dob) {
    if (!dob) return '';
    const [ date ] = dob.split("T");
    const [ year, month, day ] = date.split("-");

    return `${ month }/${ day }/${ year }`;
}

export const dateTimeFormatter = (date) => {
    return dayjs.utc(date).format("MM/DD/YYYY hh:mm A") + ' UTC';
}

export const unixDateTimeFormatter = (date) => {
    return dayjs.unix(date).format("MM/DD/YYYY hh:mm A");
}


export const timeFormatter = (date) => {
    return dayjs(date).format("hh:mm A");
}